import { login, logout } from '@/api/user';
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/token';
import {
  resetRouter
} from '@/router';

const state = {
  token: getToken(),
  roles: [],
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
};

const actions = {
  // user login
  async login({
    commit
  }, userInfo) {
    const {
      username,
      password,
      uuid,
      code
    } = userInfo;
    let result = await login({
      username: username.trim(),
      password: password,
      uuid: uuid,
      code: code
    });

    if (result.code !== 200) {
      throw new Error('login failed');
    }
    commit('SET_TOKEN', result.data);
    setToken(result.data);
  },


  // remove token
  resetToken({ commit }) {
    commit('SET_TOKEN', '');
    commit('SET_ROLES', []);
    removeToken();
  },

  // user logout
  async logout({ state, dispatch }) {
    if (state.token) {
      await logout(state.token);
    }
    await dispatch('resetToken');
    resetRouter();
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
